// VERFICAR PARA EXCLUIR ESTE ARQUIVO
import React from 'react';
import {
    Container, Row, Col
} from 'reactstrap';
import MenuNew from '../MenuNew';
import Sidebar from '../Sidebar/MenuLeft';
import NavbarDrop from '../HomePageNew/NavbarDrop';
import Footer from '../HomePageNew/Footer';


import '../../assets/css/icon_report.css';



class Page extends React.Component {

    render() {
        return (
            <div>
                <MenuNew />
                <NavbarDrop />

                <Container id="wallet_slip">
                    <div className="wallet_slip_img_inst">
                        <Row style={{ marginRight: 0 }}>
                            <Col style={{ marginTop: 90 }} xs="12" sm="12" md="2" lg="2" xl="2">{''}</Col>

                            <Col id="wallet_slip_app_text" xs="12" sm="12" md="8" lg="8" xl="8">
                                <h1>RELATÓRIOS DE GESTÃO</h1>
                            </Col>

                            <Col style={{ marginTop: 60 }} xs="12" sm="12" md="2" lg="2" xl="2">{''}</Col>
                        </Row>
                    </div>


                </Container>

                <Container style={{ marginTop: -40 }} >
                    <Row style={{ marginRight: 0 }}>
                        <Col style={{ marginTop: 60, marginRight: 35 }} xs="12" sm="12" md="2" lg="2" xl="4">
                            <Sidebar />
                        </Col>
                        <Col style={{ marginTop: 60, margiLeft: 20 }} xs="12" sm="12" md="10" lg="10" xl="7">
                            <p className="text_footer">RELATÓRIOS DE GESTÃO</p>
                            <div className="line_footer_gradient">{""}</div>     

                            <Row style={{ paddingLeft: 8 }}>
                            <Col style={{
                                    marginTop: 60,
                                    margiLeft: 20,
                                    height: 85,
                                    paddingTop: 12,
                                    backgroundColor: '#8bc34a'
                                }}
                                    xs="2" sm="2" md="" lg="2" xl="2">
                                    <div className='icon_report'></div>
                                </Col>
                                <Col style={{ marginTop: 60, backgroundColor: 'white', paddingTop: 33 }} xs="10" sm="10" md="10" lg="10" xl="10">
                                 {/*   <div className='title_report' style={{ cursor: 'pointer' }} ><a href='/assets/pdf/demonstrativo_financeiro_2022.pdf'>DEMONSTRATIVOS FINANCEIROS 2022</a></div> */} 
                                 <div className='title_report' style={{ cursor: 'pointer' }} ><a href='/assets/pdf/gestao_sustentabilidade_2022.pdf'>RELATÓRIO DE GESTÃO E SUSTENTABILIDADE 2022</a></div> 
                                </Col>
                            </Row>  

                            <Row style={{paddingLeft: 8}}>
                                <Col style={{ 
                                    marginTop: 60, 
                                    margiLeft: 20, 
                                    height: 85,
                                    paddingTop: 12,
                                    backgroundColor:'rgba(245, 170, 0, 0.72)' }} 
                                    xs="2" sm="2" md="" lg="2" xl="2">
                                    <div className='icon_report'></div>
                                </Col>
                                <Col style={{ marginTop: 60, backgroundColor: 'white', paddingTop:33 }} xs="10" sm="10" md="10" lg="10" xl="10">
                                    <div className='title_report' style={{ cursor: 'pointer' }} ><a href='/assets/pdf/gestao_sustentabilidade_2021.pdf'>RELATÓRIO DE GESTÃO E SUSTENTABILIDADE 2021</a></div>
                                </Col>
                                
                           </Row> 
                           <Row style={{ paddingLeft: 8 }}>
                                <Col style={{
                                    marginTop: 60,
                                    margiLeft: 20,
                                    height: 85,
                                    paddingTop: 12,
                                    backgroundColor: '#8bc34a'
                                }}
                                    xs="2" sm="2" md="" lg="2" xl="2">
                                    <div className='icon_report'></div>
                                </Col>
                                <Col style={{ marginTop: 60, backgroundColor: 'white', paddingTop: 33 }} xs="10" sm="10" md="10" lg="10" xl="10">
                                    <div className='title_report' style={{ cursor: 'pointer' }} ><a href='/assets/pdf/sustentabilidade2020.pdf'>RELATÓRIO DE GESTÃO E SUSTENTABILIDADE 2020</a></div>
                                </Col>

                            </Row>                           


                            <Row style={{paddingLeft: 8}}>
                                <Col style={{ 
                                    marginTop: 60, 
                                    margiLeft: 20, 
                                    height: 85,
                                    paddingTop: 12,
                                    backgroundColor:'rgba(245, 170, 0, 0.72)' }} 
                                    xs="2" sm="2" md="" lg="2" xl="2">
                                    <div className='icon_report'></div>
                                </Col>
                                <Col style={{ marginTop: 60, backgroundColor: 'white', paddingTop:33 }} xs="10" sm="10" md="10" lg="10" xl="10">
                                    <div className='title_report' style={{ cursor: 'pointer' }} ><a href='/assets/pdf/sustentabilidade2019.pdf'>RELATÓRIO DE GESTÃO E SUSTENTABILIDADE 2019</a></div>
                                </Col>
                                
                           </Row>
                           <Row style={{ paddingLeft: 8 }}>
                                <Col style={{
                                    marginTop: 60,
                                    margiLeft: 20,
                                    height: 85,
                                    paddingTop: 12,
                                    backgroundColor: '#8bc34a'
                                }}
                                    xs="2" sm="2" md="" lg="2" xl="2">
                                    <div className='icon_report'></div>
                                </Col>
                                <Col style={{ marginTop: 60, backgroundColor: 'white', paddingTop: 33 }} xs="10" sm="10" md="10" lg="10" xl="10">
                                    <div className='title_report' style={{ cursor: 'pointer' }} ><a href='/assets/pdf/gestao_financeira_2018.pdf'>RELATÓRIO DE GESTÃO 2018</a></div>
                                </Col>

                            </Row>
                             
                        </Col>
                    </Row>
                </Container>

                <Footer />
            </div>

        );
    }
}
export default Page;



/** WEBPACK FOOTER **
 ** ./src/components/Transparencia/Page.js
 **/